<template>
<div id="app">
    <layout>
        <router-view></router-view>
    </layout>
</div>
</template>

<script>
import Layout from './components/Layout.vue'
export default {
    name: 'app',
    components:{
        Layout
    },
    mounted(){
        const token = localStorage.getItem('token')
        const userId = localStorage.getItem('userId')
        const userName = localStorage.getItem('userName')
        if (!token || !userId){
            this.$router.push('/login')
        }
        this.$store.commit('UpdateState',{token,userId,userName})
    },
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.logo {
    position: relative;
    width: 30%;
    margin-bottom: 40px;
}
body{
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue